import * as service from './service';

export const permissionsStore = {
  service,
};
